import SupaBaseModel from "./SupaBaseModel";

export default class Page extends SupaBaseModel {
    static data_name = 'pages';

    static async getContentForPath(path){
        let result = await this.find({ path: path });
        console.log("result", result);
        return result == null ? null : result.content;
    }
}